"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _modal = _interopRequireDefault(require("./modal.c"));

var _base = _interopRequireDefault(require("./base.c"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _renderprops = require("react-spring/renderprops");

var Popup =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Popup, _React$Component);

  function Popup() {
    (0, _classCallCheck2["default"])(this, Popup);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).apply(this, arguments));
  }

  (0, _createClass2["default"])(Popup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          root = _this$props.root,
          fx = _this$props.fx,
          children = _this$props.children,
          style = _this$props.style,
          open = _this$props.open,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["root", "fx", "children", "style", "open"]);
      return _react["default"].createElement(_renderprops.Transition, {
        items: open,
        "native": true,
        from: {
          opacity: 0
        },
        enter: {
          opacity: 1
        },
        leave: {
          opacity: 0
        },
        config: {
          duration: 150
        }
      }, function (open) {
        return open && function (props) {
          return _react["default"].createElement(_modal["default"], {
            root: root,
            fx: fx,
            style: style
          }, _react["default"].createElement(_renderprops.animated.div, {
            style: props
          }, _react["default"].createElement(_base["default"], (0, _extends2["default"])({}, rest, {
            style: style
          }), children)));
        };
      });
    }
  }]);
  return Popup;
}(_react["default"].Component);

(0, _defineProperty2["default"])(Popup, "defaultProps", {
  open: true
});
(0, _defineProperty2["default"])(Popup, "propTypes", {
  root: _propTypes["default"].any,
  children: _propTypes["default"].any,
  fx: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  open: _propTypes["default"].bool.isRequired,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @default Close
     */
    appearance: _propTypes["default"].string,

    /**
     * @default rgba(0, 0, 0, 0.3)
     */
    overlayBackground: _propTypes["default"].string,

    /**
     * @default palette.zMaximal
     */
    overlayZIndex: _propTypes["default"].string,

    /**
     * @default palette.elPrimary
     */
    background: _propTypes["default"].string,

    /**
     * @default 3px
     */
    borderRadius: _propTypes["default"].string,

    /**
     * @default visible
     */
    overflow: _propTypes["default"].string,

    /**
     * @default 0 8px 12px 0 ${palette.elShadow}, 0 6px 12px 0 ${palette.elShadow}
     */
    boxShadow: _propTypes["default"].string
  })
});
(0, _defineProperty2["default"])(Popup, "displayName", 'Popup');
var _default = Popup;
exports["default"] = _default;